var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidLeafIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51764 17.9867C9.41075 16.1517 10.1768 14.103 11.7623 12.5175C15.1401 9.13969 22.0913 9.52255 22.438 9.54165L22.4514 9.54234C22.4336 9.57797 17.1781 17.2028 10.9428 17.9154C10.4618 17.9689 9.98083 17.9867 9.51764 17.9867Z",
    fill: "#A2A2A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2453 20.3196C10.4235 20.6047 10.6373 20.8719 10.8867 21.1035C13.0245 23.2413 16.8725 22.8494 19.4913 20.2127C22.9653 16.7388 22.4665 9.5237 22.4665 9.5237L22.4623 9.53274C22.3197 9.84496 18.5701 18.0527 12.686 19.8564C11.8487 20.1237 11.0292 20.284 10.2453 20.3196Z",
    fill: "#A2A2A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16Z",
    fill: "#A2A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidLeafIcon);
export default __webpack_public_path__ + "static/media/bfid-leaf-icon.26083df5c6df2b5161543e5798c97ba9.svg";
export { ForwardRef as ReactComponent };